<template>
   <div class="main">
       <div class="nav" > 
        <Nav title="使用指南" :fixed="true"></Nav>
        <div class="top"></div>
       </div>
       <div class="img">
           <van-image
           :src="$global.account_url+url" 
           >
           </van-image>
       </div>
   </div>
</template>

<script>
import Nav from '@/components/nav.vue'
export default {
 components:{
     Nav,
 },
 data(){
     return{
        url:"",
     }
 },
 mounted(){
     this.getbgimg()
 },
 methods: {
      async getbgimg(){
      //请求医院信息
      try {
        this.$showLoad()
        this.isLoad = true
        let url = '/register/getuserguideimg'
       await this.$axios_request.request_data("nodeserver", url, "post", null,(data)=>{
        //医院名
        console.log(data)
        this.url=data.data
        this.$hideLoad()
       });
      } catch (error) {
        console.log(error)
        this.$hideLoad()
        this.$toast.fail('网络连接失败');
      }
    },
 },
}
</script>

<style lang="scss" scoped>
 .main{
     .nav{
         .top{
         height: 30px;
         width: 1px;
     }
     }
     .img{
         width: 95%;
         margin: 0px auto;
     }
 }
</style>